/**
 * Woocommerce related JS
 */

// Move Login Box on checkout
if (document.querySelector('body').classList.contains('woocommerce-checkout')) {

  const loginBox = document.querySelector('.box--checkout-login');

  if (loginBox) {
    const parent = document.querySelector('#customer_details');
    parent.prepend(loginBox);
    loginBox.style.opacity = 1;
  }
}
